<template>
  <div class="flex-1 flex flex-col bg-white-005 px-6 py-4 rounded-2xl mb-6 md:mb-0">
    <div class="text-xl font-bold mb-6">Top FT Assets</div>

    <div class="flex-1 min-h-0" ref="container">
      <VChart
        ref="chart"
        v-if="!loading"
        class="w-72 md:w-full h-72 md:h-full"
        :option="option"
        :key="width"
      ></VChart>
      <div v-else class="w-full h-full flex justify-center items-center">
        <Spin></Spin>
      </div>
    </div>
  </div>
</template>

<script setup>
import { queryFtRank } from '@/api/dao';
import Spin from '@/components/Spin.vue';
import { chartColor } from '@/constants';
import { useReqByBool } from '@/hooks';
import { formatVal } from '@/utils';
import { useElementSize } from '@vueuse/core';
import { TreemapChart } from 'echarts/charts';
import {
  GraphicComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { ref, computed, inject, onMounted, reactive, watch } from 'vue';
import VChart from 'vue-echarts';
import { homeChains } from '../constant';
const chart = ref(null);

const container = ref(null);

const { width, height } = useElementSize(container);
use([
  CanvasRenderer,
  TreemapChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  GraphicComponent,
]);

const homeState = inject('homeState');

const state = reactive({
  list: [],
});

const option = computed(() => {
  const list = JSON.parse(JSON.stringify(state.list));

  const sum = list.reduce((a, b) => {
    return a + b.totalUsd;
  }, 0);

  list.forEach((x) => {
    x.rate = ((x.totalUsd / sum) * 100).toFixed(2);
  });

  return {
    color: chartColor,
    tooltip: {
      borderColor: '#FFFFFF66',
      backgroundColor: '#1e1f21bb',
      textStyle: {
        color: '#fff',
        fontSize: 12,
      },
      formatter(conf) {
        const { dataIndex } = conf;
        const info = list[dataIndex - 1];
        return `${info?.symbol} ${info?.rate}% ${formatVal(info?.totalUsd, {
          omit: true,
          bit: 2,
        })}`;
      },
    },
    series: [
      {
        left: 0,
        right: 0,
        bottom: 0,
        top: 0,
        type: 'treemap',
        nodeClick: false,
        roam: false,
        upperLabel: {
          show: false,
        },
        breadcrumb: {
          show: false,
        },
        data: list.map((x) => ({
          name: x.symbol,
          value: x.totalUsd,
          label: {
            fontSize: Math.max(Math.floor(64 * (x.rate / 100)), 14),
          },
        })),
        label: {
          fontSize: 16,
          fontWeight: 'bold',
          formatter: ({ data, dataIndex }) => {
            const info = list[dataIndex - 1];

            return `${info?.symbol}\n$${formatVal(info?.totalUsd, {
              omit: true,
              bit: 2,
            })}\n${info?.rate}%`;
          },
        },
      },
    ],
  };
});

const { loadData, loading } = useReqByBool(async () => {
  const res = await queryFtRank(
    homeChains[homeState.selectedChain].value,
    homeState.filterStatus,
  );
  console.log(res);

  state.list = res;
});

watch(() => [homeState.selectedChain, homeState.filterStatus], loadData);

onMounted(loadData);
</script>

<style lang="scss" scoped></style>
